import React, { useState } from 'react';
import { useOverflow } from '../../../hooks/useOverflow';

import styles from './AlertDescription.module.scss';

type Props = {
  /**
   * The content to render for the description.
   */
  children: React.ReactNode;
  /**
   * The maximum number of lines to render before truncating.
   */
  maxLines?: number;
};

/**
 * `AlertDescription` renders the description for an `Alert`.
 */
export const AlertDescription = ({ children, maxLines = 3 }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOverflowing, setOverflowingNode] = useOverflow();

  // Only render toggle if it's overflowing.
  const toggle = isOverflowing && (
    <button
      className={styles.toggle}
      onClick={() => setIsOpen(!isOpen)}
      type="button"
      data-zds
    >
      {isOpen ? 'show less' : 'show more'}
    </button>
  );

  return (
    <div className={styles.root} data-zds>
      <div
        className={styles.content}
        data-zds
        ref={setOverflowingNode}
        style={
          {
            '--line-clamp': isOpen ? 'initial' : maxLines,
          } as React.CSSProperties
        }
      >
        <div data-zds>{children}</div>
      </div>
      {toggle}
    </div>
  );
};
